@if (guia2.length != 0) {
  <app-guia-component [GUIA_KEY]="'GUIA II'" [data]="guia2"></app-guia-component>
} @else {
  <app-empty-state
    [message] = "guideTwoComponent()?.emptyStateMessage"
  ></app-empty-state>
  <br>
}
<div class="container-btn">
  <button type="button" (click)="handleGoBack()">
    {{ guideTwoComponent()?.backButton }}
  </button>
</div>



